var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "error-store" },
    [
      _c(
        "Badge",
        { attrs: { dot: "", count: _vm.countComputed } },
        [
          _c(
            "Button",
            { attrs: { type: "text" }, on: { click: _vm.openErrorLoggerPage } },
            [_c("Icon", { attrs: { size: 20, type: "ios-bug" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }